import React from 'react';
import { trackAddToCart } from '../../utils/pixel';
export function Hero() {
  return <section className="w-full bg-[#FAFAF8] min-h-screen flex items-center" data-id="element-94">
      <div className="max-w-7xl mx-auto px-6 py-16 lg:py-0 w-full" data-id="element-95">
        <div className="flex flex-col-reverse lg:flex-row items-center gap-12 lg:gap-16 min-h-screen lg:py-20" data-id="element-96">
          {/* Left: Text + CTA */}
          <div className="flex-1 flex flex-col justify-center" data-id="element-97">
            {/* Eyebrow */}
            <span className="inline-block text-xs font-semibold tracking-widest uppercase mb-5" style={{
            color: '#FF5A5F',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-98">
              Sistema de Operación Zero-Touch
            </span>

            {/* H1 */}
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-tight mb-5" style={{
            color: '#1A1A1A',
            fontFamily: 'Plus Jakarta Sans, sans-serif'
          }} data-id="element-99">
              Automatiza tu Airbnb
              <br data-id="element-100" />
              y Recupera tu
              <br data-id="element-101" />
              Libertad.
            </h1>

            {/* Subhead */}
            <p className="text-xl sm:text-2xl font-bold mb-5" style={{
            color: '#1A1A1A',
            fontFamily: 'Plus Jakarta Sans, sans-serif'
          }} data-id="element-102">
              Reseñas de 5 Estrellas. Sin Estrés.
            </p>

            {/* Body */}
            <p className="text-base sm:text-lg leading-relaxed mb-8 max-w-lg" style={{
            color: '#6B7280',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-103">
              Automatiza la hospitalidad de tus rentas cortas, recupera tu
              tiempo y garantiza reseñas de 5 estrellas sin responder mensajes a
              media noche.
            </p>

            {/* CTA Button */}
            <a href="https://www.oniyeyeo.com/cart/43011413868611:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} className="inline-block text-center text-white font-bold text-base sm:text-lg px-8 py-5 rounded-xl shadow-lg transition-all duration-200 hover:shadow-xl hover:-translate-y-0.5 active:translate-y-0 mb-4" style={{
            backgroundColor: '#FF5A5F',
            fontFamily: 'Plus Jakarta Sans, sans-serif'
          }} onMouseEnter={e => e.currentTarget.style.backgroundColor = '#E84E53'} onMouseLeave={e => e.currentTarget.style.backgroundColor = '#FF5A5F'} data-id="element-104">
              ¡QUIERO AUTOMATIZAR MI AIRBNB AHORA!
            </a>

            {/* Trust text */}
            <p className="text-sm text-center" style={{
            color: '#6B7280',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-105">
              💳 Pago único de $6.39 USD · Acceso de por vida · Sin
              suscripciones
            </p>
          </div>

          {/* Right: Hero Image */}
          <div className="flex-1 flex justify-center lg:justify-end w-full max-w-xl lg:max-w-none" data-id="element-106">
            <img src="https://cdn.magicpatterns.com/uploads/pJ653oJWiahrFktqkAGQ5G/heylloyd-image-1772295288366.png" alt="Anfitrión relajado en balcón con laptop y café, gestionando su Airbnb sin estrés" className="w-full max-w-md lg:max-w-lg xl:max-w-xl rounded-2xl shadow-2xl object-cover" data-id="element-107" />
          </div>
        </div>
      </div>
    </section>;
}